import {ajax} from "utils/ajax.js"
export const categoryApi =  async () =>{
    const response= await ajax(null, 'Warehouse/Categories', 'POST', true)
    if(response?.data?.success===true){
        return response?.data
    }
}

export const subjectsApi = async (id) =>{
    const response= await ajax(null,`Warehouse/Catgories/${id}/Subjects` , 'POST', true)
    if(response?.data?.success===true){
        return response?.data
    }
}

export const FiltersApi = async (id) =>{
    const response=  await ajax(null,`Warehouse/Catgories/${id}/Filters` , 'POST', true)
    if(response?.data?.success===true){
        return response?.data
    }
}
export const ResultApi = async (data) =>{
    const params = {"ids": data}
    const response= await ajax(null,`Warehouse/Data` , 'POST', true , params)
    if(response?.data?.success===true){
        return response?.data
    }
}

export const SearchApi = async (data) =>{
    const response= await ajax(null,`Warehouse/Search` , 'POST', true , data)
    if(response?.data?.success===true){
        return response?.data
    }
}

export const loginApi = async (data) =>{
    const response= await ajax(null,`auth` , 'POST', true , data)
    return response.data;
}